var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Confirm")]),_c('p',[_vm._v(_vm._s(_vm.data.message || 'Are you sure?'))]),_c('button',{on:{"click":_vm.close}},[_vm._v("Cancel")]),_c('button',{on:{"click":_vm.close}},[_vm._v("Confirm")])])
}
var staticRenderFns = []

export { render, staticRenderFns }